/**
 * Helpers para derivar pedidos/ambientes da planilha legada (useDados).
 *
 * No legado, cada LINHA de `dados` = 1 ambiente. O "pedido" eh apenas a
 * coluna NUM. PEDIDO. Aqui agrupamos as linhas por numero de pedido para
 * montar o seletor (cliente + lista de ambientes daquele pedido).
 */

import { F } from "../../utils/gerencialFields";
import { isMeaningfulIdentifier } from "../../utils/clientes";

function txt(v) {
  return String(v ?? "").trim();
}

/**
 * Agrupa `dados` por numero de pedido (descartando pedidos vazios/0).
 * Retorna [{ pedido, cliente, ambientes: [nome] }] ordenado por pedido desc.
 */
export function agruparPedidos(dados) {
  const map = new Map();
  (dados || []).forEach((row) => {
    const pedido = row[F.NUMERO_DO_PEDIDO];
    if (!isMeaningfulIdentifier(pedido)) return;
    const key = txt(pedido);
    if (!map.has(key)) {
      map.set(key, { pedido: key, cliente: txt(row[F.NOME_DO_CLIENTE]), ambientes: [] });
    }
    const entry = map.get(key);
    if (!entry.cliente) entry.cliente = txt(row[F.NOME_DO_CLIENTE]);
    const amb = txt(row[F.AMBIENTE]);
    if (amb && !entry.ambientes.includes(amb)) entry.ambientes.push(amb);
  });
  return Array.from(map.values()).sort((a, b) =>
    String(b.pedido).localeCompare(String(a.pedido), undefined, { numeric: true }),
  );
}

/** Acha 1 pedido agrupado pelo numero (string). */
export function pedidoPorNumero(dados, numPedido) {
  if (!numPedido) return null;
  return (
    agruparPedidos(dados).find((p) => String(p.pedido) === String(numPedido)) || null
  );
}
